import React from 'react';
import { Alert, Box, Typography, Button } from '@mui/material';

interface NoBoxesAlertProps {
  className?: string;
  onGoToBoxManagement?: () => void;
}

const NoBoxesAlert: React.FC<NoBoxesAlertProps> = ({ className, onGoToBoxManagement }) => {
  return (
    <Box sx={{ mb: 3 }} className={className}>
      <Alert
        severity="warning"
        sx={{
          '& .MuiAlert-message': {
            width: '100%'
          }
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { sm: 'center' }, justifyContent: 'space-between', width: '100%' }}>
          <Typography variant="body1">
            No boxes in your inventory yet. Add a few in Box Management to start finding packaging.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={onGoToBoxManagement}
            sx={{ mt: { xs: 1, sm: 0 } }}
          >
            Go to Box Management
          </Button>
        </Box>
      </Alert>
    </Box>
  );
};

export default NoBoxesAlert; 